import { useNuxtApp } from '#app';
import { BaseService } from '../base/base.service';
import type { IModelResponse } from '../base/dto/base.dto';
import { ModelSubDepartmentList } from './dto/quota-sub-department.dto';
import {
  ModelQuota,
  ModelQuotaDepartment,
  ModelQuotaDetail,
  ModelQuotaLimit,
  ModelQuotaList,
  ModelQuotaOverallDetail,
  ModelUserQuotaBySuperAdmin,
  type IModelCreateQuotaRequest,
} from './dto/quota.dto';
import { ModelQuotaLimits, ModelQuotaByModel } from './dto/super-admin-quota.dto';
import { QuotaRepository } from './quota.repository';

export class QuotaService extends BaseService {
  private quotaRepository = new QuotaRepository(this.api, this.configService);

  async getQuota(params: any): Promise<IModelResponse<ModelQuotaList[]>> {
    let dataResult: IModelResponse<ModelQuotaList[]> = {
      data: [],
    };
    const { $functions } = useNuxtApp();
    try {
      const res = await this.quotaRepository.getQuota(params);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        const dataList = (resData.data || []).map((e) => new ModelQuotaList(e));
        dataResult.data = dataList;
        dataResult.totalItems = resData.totalItems;
        console.log('getQuota', resData.data, dataResult);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
        isError: true,
      });
      console.log(err, QuotaService.name);
    }
    return dataResult;
  }

  async getQuotaById(id: string | number): Promise<ModelQuotaDetail> {
    let dataResult: ModelQuotaDetail = new ModelQuotaDetail();
    const { $functions } = useNuxtApp();
    try {
      const res = await this.quotaRepository.getQuotaById(id);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = new ModelQuotaDetail(resData.data);
        console.log('getQuota', resData.data, dataResult);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
        isError: true,
      });
      console.log(err, QuotaService.name);
    }
    return dataResult;
  }

  async createQuota(
    params: IModelCreateQuotaRequest
  ): Promise<ModelQuota | undefined> {
    let dataResult;
    const { $functions } = useNuxtApp();
    try {
      const res = await this.quotaRepository.createQuota(params);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = new ModelQuota(resData.data);
        console.log('createQuota', resData.data, dataResult);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
        isError: true,
      });
      console.log(err, QuotaService.name);
    }
    return dataResult;
  }

  async updateQuota(
    params: IModelCreateQuotaRequest
  ): Promise<ModelQuotaLimit[] | undefined> {
    let dataResult;
    const { $functions } = useNuxtApp();
    try {
      const res = await this.quotaRepository.updateQuota(params);

      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = (resData.data || []).map(
          (e: any) => new ModelQuotaLimit(e)
        );
        console.log('updateQuota', resData.data, dataResult);
      }
    } catch (err: any) {
      // $functions.notify.error({
      //   text: err,
      //   isError: true,
      // });
      console.log(err, QuotaService.name);
    }
    return dataResult;
  }

  async updateOverallQuota(
    params: any
  ): Promise<ModelQuotaOverallDetail | undefined> {
    let dataResult;
    const { $functions } = useNuxtApp();
    try {
      const res = await this.quotaRepository.updateOverallQuota(params);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = new ModelQuotaOverallDetail(resData.data);
        console.log('updateOverallQuota', resData.data, dataResult);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
        isError: true,
      });
      console.log(err, QuotaService.name);
    }
    return dataResult;
  }

  async getQuotaDepartment(
    params: any
  ): Promise<IModelResponse<ModelQuotaDepartment[]>> {
    let dataResult: IModelResponse<ModelQuotaDepartment[]> = {
      data: [],
    };
    const { $functions } = useNuxtApp();
    try {
      const res = await this.quotaRepository.getQuotaDepartment(params);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        const dataList = (resData.data || []).map(
          (e) => new ModelQuotaDepartment(e)
        );
        dataResult.data = dataList;
        dataResult.totalItems = resData.totalItems;
        console.log('getQuotaDepartment', resData.data, dataResult);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
        isError: true,
      });
      console.log(err, QuotaService.name);
    }
    return dataResult;
  }
 
  async getQuotaSupDepartment(
    params: any
  ): Promise<IModelResponse<ModelSubDepartmentList[]>> {
    let dataResult: IModelResponse<ModelSubDepartmentList[]> = {
      data: [],
    };
    const { $functions } = useNuxtApp();
    try {
      const res = await this.quotaRepository.getQuotaSupDepartment(params);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        const dataList = (resData.data || []).map(
          (e) => new ModelSubDepartmentList(e)
        );
        dataResult.data = dataList;
        dataResult.totalItems = resData.totalItems;
        console.log('getQuotaDepartment', resData.data, dataResult);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
        isError: true,
      });
      console.log(err, QuotaService.name);
    }
    return dataResult;
  }

  async getOverallQuota(): Promise<number> {
    let overallQuota = 0;
    const { $functions } = useNuxtApp();
    try {
      const res = await this.quotaRepository.getOverallQuota();
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        overallQuota = resData.data?.overallQuota || 0;
        console.log('getOverallQuota', resData.data, overallQuota);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
        isError: true,
      });
      console.log(err, QuotaService.name);
    }
    return overallQuota;
  }

  async getSupDepartmentQuotaBySuperAdmin(params: any): Promise<IModelResponse<ModelSubDepartmentList[]>> {
    let dataResult: IModelResponse<ModelSubDepartmentList[]> = {
      data: [],
    };
    const { $functions } = useNuxtApp();
    try {
      const res = await this.quotaRepository.getSupDepartmentQuotaBySuperAdmin(params);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        const dataList = (resData.data || []).map(
          (e) => new ModelSubDepartmentList(e)
        );
        dataResult.data = dataList;
        dataResult.totalItems = resData.totalItems;
        console.log('getSupDepartmentQuotaBySuperAdmin', resData.data, dataResult);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
        isError: true,
      });
      console.log(err, QuotaService.name);
    }
    return dataResult;
  }

  async getFunctionCodeQuotaBySuperAdmin(params: any): Promise<IModelResponse<ModelSubDepartmentList[]>> {
    let dataResult: IModelResponse<ModelSubDepartmentList[]> = {
      data: [],
    };
    const { $functions } = useNuxtApp();
    try {
      const res = await this.quotaRepository.getFunctionCodeQuotaBySuperAdmin(params);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        const dataList = (resData.data || []).map(
          (e) => new ModelSubDepartmentList(e)
        );
        dataResult.data = dataList;
        dataResult.totalItems = resData.totalItems;
        console.log('getFunctionCodeQuotaBySuperAdmin', resData.data, dataResult);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
        isError: true,
      });
      console.log(err, QuotaService.name);
    }
    return dataResult;
  }

  async getUserQuotaBySuperAdmin(params: any): Promise<IModelResponse<ModelUserQuotaBySuperAdmin[]>> {
    let dataResult: IModelResponse<ModelUserQuotaBySuperAdmin[]> = {
      data: [],
    };
    const { $functions } = useNuxtApp();
    try {
      const res = await this.quotaRepository.getUserQuotaBySuperAdmin(params);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        const dataList = (resData.data || []).map(
          (e) => new ModelUserQuotaBySuperAdmin(e)
        );
        dataResult.data = dataList;
        dataResult.totalItems = resData.totalItems;
        console.log('getUserQuotaBySuperAdmin', resData.data, dataResult);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
        isError: true,
      });
      console.log(err, QuotaService.name);
    }
    return dataResult;
  }

  async getSupDepartmentOverallQuota(id: string | number, isNonSubDepartment?: boolean): Promise<ModelQuotaLimits | ModelQuotaByModel> {
    let dataResult: ModelQuotaLimits | ModelQuotaByModel = isNonSubDepartment ? new ModelQuotaByModel() : new ModelQuotaLimits();
    const { $functions } = useNuxtApp();
    try {
      const res = await this.quotaRepository.getSupDepartmentOverallQuota(id);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        if (isNonSubDepartment) {
          dataResult = new ModelQuotaByModel(resData.data);
        } else {
          dataResult = new ModelQuotaLimits(resData.data);
        }
        console.log('getSupDepartmentOverallQuota', resData.data, dataResult);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
        isError: true,
      });
      console.log(err, QuotaService.name);
    }
    return dataResult;
  }
}
